const PLATFORMS = {
  DPONET: 'dponet',
  DPO_EASY: 'dpoEasy',
  ADVISOR: 'advisor',
}

const TRANSLATED_PLATFORMS = {
  [PLATFORMS.DPONET]: 'DPOnet',
  [PLATFORMS.DPO_EASY]: 'DPOEasy',
  [PLATFORMS.ADVISOR]: 'Advisor',
}

const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

const TRANSLATED_STATUS = {
  [STATUS.ACTIVE]: 'Ativo',
  [STATUS.INACTIVE]: 'Inativo',
}

const STATUS_OPTIONS = [
  { id: STATUS.ACTIVE, name: TRANSLATED_STATUS[STATUS.ACTIVE] },
  { id: STATUS.INACTIVE, name: TRANSLATED_STATUS[STATUS.INACTIVE] },
]

const regulations = {
  PLATFORMS,
  TRANSLATED_PLATFORMS,
  STATUS,
  TRANSLATED_STATUS,
  STATUS_OPTIONS,
}

export default regulations
